import { render } from "./MonthValue.vue?vue&type=template&id=1766c6ac&scoped=true"
import script from "./MonthValue.vue?vue&type=script&lang=js"
export * from "./MonthValue.vue?vue&type=script&lang=js"

import "./MonthValue.vue?vue&type=style&index=0&id=1766c6ac&scoped=true&lang=css"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1766c6ac"]])

export default __exports__